<ng-container *transloco="let t">
  <div class="modal-header">
    <h2>{{ t('saveAllDialog/title') }}</h2>
    <p [innerHTML]="t('saveAllDialog/subtitle', { count: changedFields.length })"></p>
  </div>

  <div class="modal-body">
    <div class="field-card" *ngFor="let field of changedFields; let i = index" [class.undecided]="submitAttempted && isUndecided(i)">
      <div class="field-header">
        <strong>{{ field.label }}</strong>
        <span
          ><span class="text-muted">{{ field.oldValueDisplay || '–' }} →</span><strong>„{{ field.newValueDisplay || '–' }}"</strong></span
        >
      </div>

      <div class="field-choices">
        <div class="form-check">
          <input
            type="radio"
            class="form-check-input circle"
            [id]="'corr_' + i"
            [name]="'choice_' + i"
            value="correction"
            [checked]="fieldChoices[i] === 'correction'"
            [disabled]="!canCorrect(i)"
            (change)="setChoice(i, 'correction')"
          />
          <label class="form-check-label" [class.text-muted]="!canCorrect(i)" [for]="'corr_' + i">
            <strong>{{ t('saveAllDialog/correctionChoiceLabel') }}</strong>
            <ng-container *ngIf="canCorrect(i) && fieldLastRecordLabels[i]">
              – {{ t('saveAllDialog/correctionChoiceDesc', { date: fieldLastRecordLabels[i] }) }}
            </ng-container>
            <ng-container *ngIf="!canCorrect(i)"> – {{ t(correctionUnavailableKey(i)) }}</ng-container>
          </label>
        </div>

        <div class="form-check">
          <input
            type="radio"
            class="form-check-input circle"
            [id]="'upd_' + i"
            [name]="'choice_' + i"
            value="update"
            [checked]="fieldChoices[i] === 'update'"
            (change)="setChoice(i, 'update')"
          />
          <label class="form-check-label" [for]="'upd_' + i">
            <strong>{{ t('saveAllDialog/updateChoiceLabel') }}</strong>
            – {{ t(updateDescKey(i), { date: todayLabel }) }}
          </label>
        </div>
      </div>

      <div class="choice-required" *ngIf="submitAttempted && isUndecided(i)">
        <i class="material-symbols-rounded">error</i>
        {{ t('saveAllDialog/choiceRequired') }}
      </div>
    </div>

    <div class="info-notice">
      <i class="material-symbols-rounded">info</i>
      <div class="content">
        <strong>{{ t('saveAllDialog/infoBox1') }}</strong>
        <strong class="second-text">{{ t('saveAllDialog/infoBox2', { date: todayLabel }) }}</strong>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <!-- Announced once after a blocked save attempt (instead of one alert per undecided card). -->
    <span class="visually-hidden" aria-live="assertive">
      <ng-container *ngIf="submitAttempted && undecidedCount > 0">{{
        t('saveAllDialog/undecidedHint', { count: undecidedCount })
      }}</ng-container>
    </span>
    <span class="footer-hint" *ngIf="undecidedCount > 0" [class.attempted]="submitAttempted">
      {{ t('saveAllDialog/undecidedHint', { count: undecidedCount }) }}
    </span>
    <button type="button" class="btn btn-outline-primary" (click)="activeModal.dismiss()">
      {{ t('saveAllDialog/cancel') }}
    </button>
    <button
      type="button"
      class="btn btn-primary"
      [class.looks-disabled]="undecidedCount > 0"
      [attr.aria-disabled]="undecidedCount > 0"
      (click)="submit()"
    >
      {{ t('saveAllDialog/confirm') }}
    </button>
  </div>
</ng-container>
